module.exports = __webpack_public_path__ + "media/images/index/product_line/pet-61db1a6d0a4f9847ce018824c14440ac.svg";